<template>
  <section>
    <ProdOutMater :pagetype="2"></ProdOutMater>
  </section>
</template>

<script>
import ProdOutMater from "../../components/ProdOutMater";
export default {
  components: { ProdOutMater },
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}
.hr-select {
  width: 100px;
}

.table-value {
  color: #23ade5;
  margin-right: 20px;
}
</style>
